export default "__VITE_ASSET__J$Z0iL_0__"